module.exports = __webpack_public_path__ + "static/media/link-stod2-app.7efd8b10.jpg";